import { render } from "./PatientInformationAdd.vue?vue&type=template&id=f47a2124"
import script from "./PatientInformationAdd.vue?vue&type=script&lang=js"
export * from "./PatientInformationAdd.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/PatientInformationAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f47a2124"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f47a2124', __exports__)) {
    console.log('reload')
    api.reload('f47a2124', __exports__)
  }
  
  module.hot.accept("./PatientInformationAdd.vue?vue&type=template&id=f47a2124", () => {
    console.log('re-render')
    api.rerender('f47a2124', render)
  })

}


export default __exports__